import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manage-equipment',
  templateUrl: './manage-equipment.component.html',
  styleUrls: ['./manage-equipment.component.scss']
})
export class ManageEquipmentComponent implements OnInit {
  
  isChecked:boolean = true;
  showCaseDetail: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  openCaseDetail(){
    this.showCaseDetail = true;
  }
 
  getCloseCaseDetail(message){
    this.showCaseDetail = message;
  }

}
